import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import Chip from '@material-ui/core/Chip'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  container: {
    width: '100%',
    height: '30px',
    minHeight: '30px',
    display: 'flex',
    justifyContent: 'center',
    marginTop: '30px',
    marginBottom: '10px'
  },
  chipContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  chip: {
    height: '30px',
    width: '100%',
    color: theme.palette.primary.main
  }
})
class FooterHistoryComponent extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    startDate: PropTypes.string.isRequired
  }
  static defaultProps = {
    startDate: moment().format()
  }

  render() {
    const { startDate, classes } = this.props
    return (
      <div className={classes.container}>
        <div className={classes.chipContainer}>
          <Chip
            label={moment(startDate).format('DD/MM - HH:mm')}
            className={classes.chip}
          />
        </div>
      </div>
    )
  }
}
export default withStyles(styles)(FooterHistoryComponent)



// WEBPACK FOOTER //
// ./src/routes/History/components/FooterHistoryComponent.js